import axiosInstance from './axiosInstance';

const dialogApi = {
    deleteDialog: (dialogId) => axiosInstance.post('/dialogs/delete', { dialogId }),
};

export default dialogApi;
